export const inr = (n) => "₹" + Number(n).toLocaleString("en-IN");

export const PLAN_META = {
  monthly: { label: "Monthly", amount: 2000 },
  quarterly: { label: "Quarterly", amount: 6000 },
  half_yearly: { label: "Half-yearly", amount: 12000 },
  annual: { label: "Annual (5% off)", amount: 22800 },
};

export const STATUS_META = {
  paid: { label: "Paid", cls: "bg-emerald-100 text-emerald-700", dot: "bg-emerald-500" },
  pending: { label: "Pending", cls: "bg-amber-100 text-amber-700", dot: "bg-amber-500" },
  overdue: { label: "Overdue", cls: "bg-red-100 text-red-700", dot: "bg-red-500" },
  awaiting: { label: "Awaiting confirm", cls: "bg-sky-100 text-sky-700", dot: "bg-sky-500" },
};

export const initialFlats = [
  { id: "f1", flat: "A-101", name: "Ramesh Kumar", plan: "monthly", status: "paid", dueNow: 0, arrears: 0, lastPaid: "03 Jun · UPI", receipts: ["RCP-2026-038 · Jun · ₹2,000"] },
  { id: "f2", flat: "A-102", name: "Priya Sharma", plan: "annual", status: "paid", dueNow: 0, arrears: 0, lastPaid: "05 Apr · Bank transfer", note: "Paid FY 26–27 upfront, 5% discount applied", receipts: ["RCP-2026-021 · FY 26–27 · ₹22,800"] },
  { id: "f3", flat: "A-103", name: "Suresh Babu", plan: "monthly", status: "overdue", dueNow: 6000, arrears: 4000, monthsPending: 3, note: "Says he'll pay after terrace leak is fixed (Issue #14)", receipts: ["RCP-2026-009 · Mar · ₹2,000"] },
  { id: "f4", flat: "A-104", name: "Lakshmi Devi", plan: "quarterly", status: "pending", dueNow: 6000, arrears: 0, receipts: ["RCP-2026-015 · Q4 FY26 · ₹6,000"] },
  { id: "f5", flat: "B-201", name: "Arun Prasad", plan: "half_yearly", status: "paid", dueNow: 0, arrears: 0, lastPaid: "10 Apr · NEFT", receipts: ["RCP-2026-024 · H1 · ₹12,000"] },
  { id: "f6", flat: "B-202", name: "Kavitha R", plan: "monthly", status: "awaiting", dueNow: 2000, arrears: 0, note: "Self-reported UPI payment — waiting for treasurer confirmation", receipts: ["RCP-2026-031 · May · ₹2,000"] },
  { id: "f7", flat: "B-203", name: "Mohammed Iqbal", plan: "monthly", status: "paid", dueNow: 0, arrears: 0, lastPaid: "01 Jun · Cash", receipts: ["RCP-2026-036 · Jun · ₹2,000 (Cash)"] },
  { id: "f8", flat: "B-204", name: "Deepa Nair", plan: "quarterly", status: "pending", dueNow: 6000, arrears: 0, receipts: ["RCP-2026-016 · Q4 FY26 · ₹6,000"] },
  { id: "f9", flat: "C-301", name: "Venkat Rao", plan: "monthly", status: "overdue", dueNow: 2000, arrears: 4000, note: "₹4,000 old arrears carried in as opening balance (pre-NivasOne)", receipts: [] },
  { id: "f10", flat: "C-302", name: "Anita Joseph", plan: "annual", status: "awaiting", dueNow: 22800, arrears: 0, note: "Forwarded bank SMS in WhatsApp — treasurer added it, pending confirm", receipts: [] },
  { id: "f11", flat: "C-303", name: "Ganesh M", plan: "monthly", status: "paid", dueNow: 0, arrears: 0, lastPaid: "02 Jun · UPI", receipts: ["RCP-2026-035 · Jun · ₹2,000"] },
  { id: "f12", flat: "C-304", name: "Rekha S", plan: "monthly", status: "paid", dueNow: 0, arrears: 0, lastPaid: "04 Jun · UPI", receipts: ["RCP-2026-039 · Jun · ₹2,000"] },
];

export const initialConfirmQueue = [
  {
    id: "pc1", flatId: "f6", flat: "B-202", name: "Kavitha R", source: "Screenshot uploaded by resident",
    parsed: { amount: 2000, date: "12 Jun 2026", utr: "415233889077", payer: "KAVITHA R", app: "Google Pay" },
    allocation: "June 2026 maintenance",
  },
  {
    id: "pc2", flatId: "f10", flat: "C-302", name: "Anita Joseph", source: "Bank SMS forwarded in WhatsApp, pasted by treasurer",
    smsText: "Your a/c XX4521 debited Rs.22,800.00 on 11-06-26 & credited to SUNRISE RESIDENCY ASSN (IMPS Ref 616223344556). -HDFC Bank",
    parsed: { amount: 22800, date: "11 Jun 2026", utr: "616223344556", payer: "ANITA JOSEPH", app: "IMPS / HDFC" },
    allocation: "Annual FY 26–27 (5% upfront discount applied)",
  },
];

export const REMINDER_TONES = {
  gentle: {
    label: "Gentle",
    text: (f) => `Namaste ${f.name.split(" ")[0]} ji 🙏 A friendly note from NivasOne: maintenance of ${inr(f.dueNow + f.arrears)} for flat ${f.flat} is pending. Kindly pay at your convenience. UPI: sunrise.assn@upi — Sunrise Residency`,
  },
  standard: {
    label: "Standard",
    text: (f) => `Reminder from NivasOne: flat ${f.flat} has pending maintenance of ${inr(f.dueNow + f.arrears)}. Please pay via UPI (sunrise.assn@upi) or bank transfer and upload the screenshot in the app. — Sunrise Residency Association`,
  },
  firm: {
    label: "Firm",
    text: (f) => `Final reminder (auto-generated by NivasOne): flat ${f.flat} has dues of ${inr(f.dueNow + f.arrears)} outstanding for ${f.monthsPending || 1}+ period(s). Kindly clear by 20 Jun to avoid this being tabled at the next committee meeting. — Sunrise Residency Association`,
  },
};
